import React from "react";
import {ClickAwayListener, Drawer, Fade, Paper} from "@mui/material";
import {useLocationStore} from "@/Stores/Site/LocationStore";
import reachGoalYM from "@/Helpers/ReachGoalYM";
import reachGoalGA from "@/Helpers/ReachGoalGA";
import Svg from "@/Components/Svg";
import useWithStore from "@/Hooks/useWithStore";
import MobileSubMenu from "@/Pages/Header/MobileSubMenu";
import CountryList from "@/Pages/Header/CountryList";
import Link from "@/Layouts/Link";

const MobileMenuDrawer = (props) => {
    const {stores = {}, config = {}, showWidget = false, city, b2bUrl = ''} = props;
    const {mobileMenuStore = {}, subMenuStore = {}, modalStore = {}} = stores;
    const {countryList} = config;

    const openModalSelectCity = useLocationStore(state => state.openModalSelectCity);

    const countryListShift = Object.assign({}, countryList[0]);

    const MobileMenuStart = () => {
        if (!subMenuStore.subMenuFlag) {
            return <>
                <div className={`nav__item`}>
                    <Link href={`/stocks`} onClick={() => mobileMenuStore.closeMobileMenu()}>Акции</Link>
                </div>
                <div className={`nav__item`}
                     onClick={() => {
                         subMenuStore.changeMobileSubMenu();
                         mobileMenuStore.closeMobileMenu()
                     }}>
                    <p>Каталог</p>
                </div>
                {/*<div className={`nav__item`}>*/}
                {/*    <Link href={`/wheel-of-fortune`} onClick={() => mobileMenuStore.closeMobileMenu()}>*/}
                {/*        Розыгрыш*/}
                {/*    </Link>*/}
                {/*</div>*/}
                {/*<div className={`nav__item`}>*/}
                {/*    <Link href={`/buket-podarkov`} onClick={() => mobileMenuStore.closeMobileMenu()}>*/}
                {/*        Розыгрыш*/}
                {/*    </Link>*/}
                {/*</div>*/}
                {/*<div className={`nav__item`}>*/}
                {/*    <Link href={`/secret-santa`} onClick={() => mobileMenuStore.closeMobileMenu()}>*/}
                {/*        Тайный Санта*/}
                {/*    </Link>*/}
                {/*</div>*/}
                <div className={`nav__item`}>
                    <Link href={`/wedding`} onClick={() => mobileMenuStore.closeMobileMenu()}>
                        Свадьба
                    </Link>
                </div>
                <div className={`nav__item`}>
                    <Link href={`/diamonds`} onClick={() => mobileMenuStore.closeMobileMenu()}>
                        Diamonds
                    </Link>
                </div>
                {/*<div className={`nav__item`}>*/}
                {/*    <Link href={`/advent-calendar`} onClick={() => mobileMenuStore.closeMobileMenu()}>*/}
                {/*        Календарь подарков*/}
                {/*    </Link>*/}
                {/*</div>*/}
                {/*<div className={`nav__item nav__item_navigation`}>*/}
                {/*    <Link href={`/collections/platina-soul`} onClick={() => mobileMenuStore.closeMobileMenu()}>*/}
                {/*        Соул-браслеты*/}
                {/*    </Link>*/}
                {/*    <div className={`icon`} onClick={() => subMenuStore.changeSubMenu('soulSubMenu')}>*/}
                {/*        <Svg id={`arrows-right`} className={`MuiSvgIcon-root`} />*/}
                {/*    </div>*/}
                {/*</div>*/}
                {/*<div className={`nav__item`}>*/}
                {/*    <Link href={`/collections`} onClick={() => mobileMenuStore.closeMobileMenu()}>*/}
                {/*        Коллекции*/}
                {/*    </Link>*/}
                {/*</div>*/}
                <div className={`nav__item`}>
                    <Link href={`/gift-certificate`} onClick={() => mobileMenuStore.closeMobileMenu()}>
                        Подарочные сертификаты
                    </Link>
                </div>
                {/*<div className={`nav__item`}>*/}
                {/*    <Link href={`/platina-benefits`} onClick={() => mobileMenuStore.closeMobileMenu()}>*/}
                {/*        Бонусная программа*/}
                {/*    </Link>*/}
                {/*</div>*/}
                {/*<div className={`nav__item`}>*/}
                {/*    <Link href={`/sber-credit-terms`} onClick={() => mobileMenuStore.closeMobileMenu()}>*/}
                {/*        Условия кредитования и рассрочки*/}
                {/*    </Link>*/}
                {/*</div>*/}
                {/*<div className={`nav__item`}>*/}
                {/*    <Link href={`/dolyame`} onClick={() => mobileMenuStore.closeMobileMenu()}>*/}
                {/*        Покупка долями*/}
                {/*    </Link>*/}
                {/*</div>*/}
                {/*<div className={`nav__item`}>*/}
                {/*    <Link href={`/split`} onClick={() => mobileMenuStore.closeMobileMenu()}>*/}
                {/*        Покупка в сплит*/}
                {/*    </Link>*/}
                {/*</div>*/}
                <div className={`nav__item`}>
                    <Link href={`/delivery`} onClick={() => mobileMenuStore.closeMobileMenu()}>
                        Оплата и доставка
                    </Link>
                </div>
                <div className={`nav__item`}>
                    <Link href={`/blog`} onClick={() => mobileMenuStore.closeMobileMenu()}>
                        Блог
                    </Link>
                </div>
                <div className={`nav__item`}>
                    <Link href={`/about-company`} onClick={() => mobileMenuStore.closeMobileMenu()}>
                        О компании
                    </Link>
                </div>
                <div className={`nav__item`}>
                    <Link href={`/contacts`} onClick={() => mobileMenuStore.closeMobileMenu()}>
                        Контакты
                    </Link>
                </div>
                <div className={`nav__item`}>
                    <a href={`${b2bUrl}/web-login`} target={`_blank`}>Кабинет партнера</a>
                </div>
                {showWidget && (
                    <div className={`nav__item`} onClick={() => modalStore.openWidgetModal()}>
                        Обратная связь
                    </div>
                )}
            </>
        }
    }

    return <Drawer
        id={`drawer`}
        className={`mobile-menu`}
        style={{zIndex: 9999}}
        anchor={`left`}
        open={mobileMenuStore.open}
        onClose={() => mobileMenuStore.closeMobileMenu()}
    >
        <div className={`mobile-menu__wrapper`}>
            <div className={`mobile-menu__top`}>
                <div className={`dagger-box dagger-box__mobile-menu`} onClick={() => mobileMenuStore.closeMobileMenu()}>
                    <Svg id={`dagger-close`} className={`svg__daggerCloseMenu`} />
                </div>
            </div>
            <div className={`mobile-menu__body`}>
                {mobileMenuStore.open && (
                    <MobileMenuStart />
                )}
                {subMenuStore.subMenuFlag && (
                    <MobileSubMenu typeSubMenu={`soulSubMenu`} {...props} />
                )}
            </div>
            <div className={`mobile-menu__footer`}>
                <ClickAwayListener onClickAway={subMenuStore.handleClickAway}>
                    <div className={`country`}>
                        <div className={`country__currentBox`} onClick={() => subMenuStore.switchingCountries()}>
                            <picture className={`country__currentFlag`}>
                                <source type={`image/webp`} srcSet={countryListShift.patchWebp} />
                                <img src={countryListShift.patch}
                                     alt={`Ru`}
                                     title={`Ru`}
                                     loading={`lazy`}
                                />
                            </picture>
                            <p className={`country__currentName`}>
                                {countryListShift.name}
                            </p>
                        </div>
                        <Fade in={subMenuStore.checked}>
                            <Paper
                                elevation={4}
                                style={{
                                    position: "absolute",
                                    top: '-135px',
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    width: 'auto',
                                    minWidth: '300px',
                                    backgroundColor: '#FFFFFF',
                                    padding: '16px',
                                    borderRadius: '8px',
                                    zIndex: 2
                                }}
                            >
                                <p className={`country__title`}>Выберите страну</p>
                                <CountryList countryList={countryList} />
                            </Paper>
                        </Fade>
                    </div>
                </ClickAwayListener>
                <div className={`mobile-menu__location`} onClick={openModalSelectCity}>
                    <Svg id={`location`} className={`svg__location`} />
                    {city}
                </div>
                <div className={`mobile-menu__phones`}>
                    <a onClick={() => {
                        reachGoalYM('phone_click');
                        reachGoalGA('phone_click');
                    }}
                       href="tel:88003501595">
                        <span className="phone">8 800 350-15-95</span>
                    </a>
                    {/*<a onClick={() => {*/}
                    {/*    reachGoalYM('phone_click');*/}
                    {/*    reachGoalGA('phone_click');*/}
                    {/*}}*/}
                    {/*   href="tel:+79109522022">*/}
                    {/*    <span className={`phone`}>8 910 952-20-22</span>*/}
                    {/*</a>*/}
                </div>
            </div>
        </div>
    </Drawer>
}

export default useWithStore(MobileMenuDrawer);
